<template>
  <div>
    <v-menu
        ref="menu1"
        v-model="menu1"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
            v-if="control.hasMask"
            v-model="dateStr"
            :class="controlFieldClass"
            :id="control.uniqueId"
            :name="control.name"
            :placeholder="control.placeholderText"
            :disabled="isDisabled"
            hint="DD/MM/AAAA"
            persistent-hint
            prepend-icon="mdi-calendar"
            v-bind="attrs"
            :readonly="control.readOnly"
            dense
            v-mask="control.mask"
            v-on="on"/>
        <v-text-field
            v-else
            v-model="dateStr"
            :class="controlFieldClass"
            :id="control.uniqueId"
            :name="control.name"
            :placeholder="control.placeholderText"
            :disabled="isDisabled"
            hint="DD/MM/AAAA"
            persistent-hint
            prepend-icon="mdi-calendar"
            v-bind="attrs"
            :readonly="control.readOnly"
            dense
            v-mask="control.mask"
            v-on="on"/>
      </template>
      <v-date-picker
          v-model="date"
          no-title
          locale="pt-br"
          show-current
          @input="menu1 = false"
      ></v-date-picker>
    </v-menu>
  </div>
</template>

<script>
import {BaseControlSkeleton} from 'v-form-builder';
import {readUserProfile} from '@/store/main/getters';
import {commitAddNotification} from '@/store/main/mutations';

export default {
  name: 'DatePickerControl',
  extends: BaseControlSkeleton,
  data: () => ({
    menu1: false,
    date: null,
    dateStr: '',
    isDisabled: false,
  }),
  computed: {},
  async mounted() {
    if (this.control.disableByRoleSetting) {
      const userProfile = readUserProfile(this.$store);
      this.isDisabled =
          !(userProfile?.role?.settings?.permissions?.can_edit_control_field?.methods?.can_edit_control_field);
    } else if (this.control.isDisabled) {
      this.isDisabled = true;
    }

    if (this.value) {
      this.date = this.value;
      this.updateValue(this.date);
    } else {
      this.updateValue('');
    }
  },

  watch: {
    date: {
      handler(cv, ov) {
        if (!cv || cv.length !== 10) {
          return null;
        }
        if (cv.includes('/')) {
          const [day, month, year] = cv.split('/');
          this.updateValue(`${year}-${month}-${day}`);
          this.dateStr = `${day}/${month}/${year}`;
        } else {
          this.updateValue(cv);
          const [year, month, day] = cv.split('-');
          this.dateStr = `${day}/${month}/${year}`;
        }
      },
      deep: true,
    },
    dateStr: {
      handler(cv, ov) {
        if (!cv || cv.length !== 10) {
          return null;
        }
        const date = this.$date(cv, 'DD/MM/YYYY');
        if (date.isValid()) {
          this.updateValue(date.format('YYYY-MM-DD'));
          this.dateStr = date.format('DD/MM/YYYY');
        } else {
          this.dateStr = '';
          commitAddNotification(this.$store, {content: 'Data inválida!', color: 'warning'});
        }
      },
    },
  },
};
</script>

<style scoped>

</style>
